import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccount } from '../../contexts/AccountContext';
import { Alert, Box, CircularProgress } from '@mui/material';
import { api } from '../../api';

export default function AuthCallback() {
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { setCurrentAccountId, setUserData } = useAccount();

    useEffect(() => {
        const processCallback = async () => {
            try {
                // Get token from URL
                const params = new URLSearchParams(window.location.search);
                const token = params.get('token');
                const error = params.get('error');

                if (error === 'unauthorized') {
                    throw new Error('This Google account is not authorized. Please contact your administrator.');
                }

                if (!token) {
                    // Check if we already have a token in localStorage
                    const storedToken = localStorage.getItem('authToken');
                    if (storedToken) {
                        console.log('Using stored token instead of URL token');
                        // Continue with stored token
                    } else {
                        throw new Error('No token received');
                    }
                } else {

                    localStorage.setItem('authToken', token);
                }

                const response = await api.get('/home');
                const { user } = response;

                if (!user || !user.email) {
                    throw new Error('Invalid user data received');
                }

                // Store user data
                localStorage.setItem('currentAccountId', user.accountId);
                localStorage.setItem('userEmail', user.email);
                localStorage.setItem('userName', user.name);
                localStorage.setItem('messagingServiceSID', user.messagingServiceSID);

                setCurrentAccountId(user.accountId);
                setUserData(user);

                navigate('/blasts', { replace: true });
            } catch (error) {
                setError(error.message || 'Failed to process authentication. Please try again.');
                localStorage.clear(); // Clear all storage on error
            }
        };

        processCallback();
    }, [navigate, setCurrentAccountId, setUserData]);

    if (error) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
                <Alert severity="error" sx={{ maxWidth: '400px' }}>
                    {error}
                </Alert>
            </Box>
        );
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
            <CircularProgress />
        </Box>
    );
} 